export default {
      id: "partner-googleAds-usage",
      viewBox: "0 0 16 16",
      url: "/" + "assets/sprite.svg#partner-googleAds",
      toString: function () {
        return this.url;
      }
    }